import { notification } from 'utils/services';

const DEFAULT_MESSAGE =
  'The request timed out due to poor internet connection. Please switch to a better network or try again later.';

const isTimeoutError = (err) => err?.code === 'ECONNABORTED' || err?.message?.includes('timeout');

const handleTimeoutError = (err, message = DEFAULT_MESSAGE) => {
  if (!isTimeoutError(err)) return false;

  notification.error(message, null, { autoClose: 15000 });
  return true;
};

export default handleTimeoutError;
